import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { Badge, Button, Icon, Palette, ShortModal } from '@sbt-web/ui';
import { OptimizelySubitoContext, userIdPrefix } from '@sbt-web/houston-wrapper';
import { PublicUser } from '@sbt-web/auth';
import classes from './index.module.scss';
export type Face2FaceBox = {
  showPayPal: boolean;
  user: PublicUser;
  urn: string;
};
export const Face2FaceBox = t0 => {
  const $ = _c(42);
  const {
    showPayPal,
    urn,
    user
  } = t0;
  const {
    optimizely
  } = useContext(OptimizelySubitoContext);
  const [step, setStep] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setStep(1);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const showFirstModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setStep(2);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showSecondModal = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setStep(0);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const closeModals = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setStep(3);
      try {
        localStorage.setItem("F2FSeen", "true");
      } catch {}
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const closeAndDoNotShowAgain = t4;
  let t5;
  if ($[4] !== optimizely || $[5] !== step || $[6] !== urn || $[7] !== user) {
    t5 = () => {
      if (!optimizely?.isReady()) {
        return;
      }
      if (step === 1) {
        optimizely.track("ViewFirstModal", `${userIdPrefix}${user.id}`, {
          urn
        });
      }
      if (step === 2) {
        optimizely.track("ViewSecondModal", `${userIdPrefix}${user.id}`, {
          urn
        });
      }
    };
    $[4] = optimizely;
    $[5] = step;
    $[6] = urn;
    $[7] = user;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== optimizely || $[10] !== step || $[11] !== user) {
    t6 = [optimizely, step, user];
    $[9] = optimizely;
    $[10] = step;
    $[11] = user;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  if (step === 3) {
    return null;
  }
  const t7 = step === 1;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [classes.modal];
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      main: {
        action: e => {
          e.preventDefault();
          showSecondModal();
        },
        text: "Procedi al pagamento",
        design: "solid"
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li className={`body-text small ${classes.listItem}`}><Icon name="Check" classes={[classes.tick]} fillColor={Palette.NeutralGrey1} /><span>Paga online e prenota l’oggetto in totale sicurezza</span></li>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <li className={`body-text small ${classes.listItem}`}><Icon name="Check" classes={[classes.tick]} fillColor={Palette.NeutralGrey1} /><span>Incontra il venditore e controlla l’oggetto dal vivo</span></li>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li className={`body-text small ${classes.listItem}`}><Icon name="Check" classes={[classes.tick]} fillColor={Palette.NeutralGrey1} /><span>Conferma l’avvenuto ritiro: solo allora i soldi verranno inviati al venditore</span></li>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ul className={classes.list}>{t10}{t11}{t12}<li className={`body-text small ${classes.listItem}`}><Icon name="Check" classes={[classes.tick]} fillColor={Palette.NeutralGrey1} /><span>Il prezzo finale include una commissione del 2% per il servizio</span></li></ul>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t7) {
    t14 = <ShortModal open={t7} ariaDescription="Acquista e ritira di persona - come funziona" bodyClasses={t8} onClose={closeModals} title="Come funziona" buttonConfiguration={t9}>{t13}</ShortModal>;
    $[19] = t7;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = step === 2;
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [classes.modal];
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      main: {
        action: e_0 => {
          e_0.preventDefault();
          closeAndDoNotShowAgain();
        },
        text: "Ok, ho capito",
        design: "solid"
      }
    };
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={classes.imageContainer}><img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/illustrations/loggati-per-vedere-i-preferiti.webp`} className={classes.image} width={160} height={120} alt="" /></div>;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className={classes.thankyou}><h3 className="headline-6">Grazie per il tuo interesse</h3><p className="body-text small">Siamo quasi pronti! Stiamo lavorando per attivare al più presto questa funzionalità. Non preoccuparti, non è stato addebitato nulla sul tuo conto.</p></div>;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t15) {
    t20 = <ShortModal open={t15} ariaDescription="Grazie per il tuo interesse" bodyClasses={t16} onClose={closeAndDoNotShowAgain} buttonConfiguration={t17}>{t18}{t19}</ShortModal>;
    $[25] = t15;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  let t22;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className={classes.badge}><Badge themed={true} inverted={true}>NOVITÀ</Badge></div>;
    t22 = <p className="caption book">Paga online in sicurezza e incontra il venditore di persona per ritirare l’articolo.</p>;
    $[27] = t21;
    $[28] = t22;
  } else {
    t21 = $[27];
    t22 = $[28];
  }
  let t23;
  let t24;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Icon name="Lock" fillColor="currentColor" />;
    t24 = <p className="caption book">Pagamento Sicuro</p>;
    $[29] = t23;
    $[30] = t24;
  } else {
    t23 = $[29];
    t24 = $[30];
  }
  let t25;
  let t26;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/mastercard.png`} alt="Mastercard" width="20" height="21" />;
    t26 = <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/visa.png`} alt="Visa" width="26" height="21" />;
    $[31] = t25;
    $[32] = t26;
  } else {
    t25 = $[31];
    t26 = $[32];
  }
  let t27;
  if ($[33] !== showPayPal) {
    t27 = showPayPal && <img src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/static/icons/payments/paypal.png`} alt="PayPal" width="30" height="21" />;
    $[33] = showPayPal;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  let t28;
  if ($[35] !== t27) {
    t28 = <div className={classes.paymentMethod}>{t23}{t24}<div className={classes.icons}>{t25}{t26}{t27}</div></div>;
    $[35] = t27;
    $[36] = t28;
  } else {
    t28 = $[36];
  }
  let t29;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className={classes.button}><Button onClick={showFirstModal} size="small" design="solid-lite" type="button">Acquista e ritira di persona</Button></div>;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] !== t14 || $[39] !== t20 || $[40] !== t28) {
    t30 = <section className={classes.face2faceBox}>{t14}{t20}{t21}{t22}{t28}{t29}</section>;
    $[38] = t14;
    $[39] = t20;
    $[40] = t28;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  return t30;
};